var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#444444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_28474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8001 16.9002C7.8001 17.6702 8.4301 18.3002 9.2001 18.3002H14.8001C15.5701 18.3002 16.2001 17.6702 16.2001 16.9002V8.5002H7.8001V16.9002ZM9.2001 9.9002H14.8001V16.9002H9.2001V9.9002ZM14.4501 6.4002L13.7501 5.7002H10.2501L9.5501 6.4002H7.1001V7.8002H16.9001V6.4002H14.4501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_28474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8,
    height: 16.8,
    fill: "white",
    transform: "translate(3.6001 3.6001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDelete);
export default __webpack_public_path__ + "static/media/profile_delete.e9ad86bc897cc63c5ccbc2d60d052c25.svg";
export { ForwardRef as ReactComponent };